import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, RaisedButton, Drawer,
  Card, CardHeader, CardText, CircularProgress
} from "material-ui";
import { ObtenerEstadosSolicitud, ObtenerTiposSolicitud } from "../../Global/actions";
import DetalleSolicitud from "../DetalleSolicitud/view";
import { GetDetalleSolicitud, GetDetalleSolicitudReajuste, GetDetalleSolicitudPaquete, GetDetalleSolicitudReajustePQ } from "../DetalleSolicitud/actions";
import TablePaginationCustom from "../../TablePagination/view";
import styles from "../../styles/styles";
import { GetFileDetalleSolicitudExcel, getDetalleSolBOConvnioReajusteExcel, OpenModalVerDetalle, GetComprobanteSolicitud, LoadingFile } from "./actions";

class GrillaSolicitudes extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerEstadosSolicitud());
    this.props.dispatch(ObtenerTiposSolicitud());
  }

  GetTipoSolicitud = (tipoS) => {
    const glosatipoS = this.props.tiposSolicitud.filter((ts) => ts.Id === tipoS);
    if (glosatipoS && glosatipoS.length === 1) {
      return glosatipoS[0].Nombre;
    }
    return "-";
  }

  GetEstadoSolicitud = (estadoS) => {
    const glosaestadoS = this.props.estadosSolicitud.filter((ts) => ts.Id === estadoS);
    if (glosaestadoS && glosaestadoS.length === 1) {
      return glosaestadoS[0].Nombre;
    }
    return "-";
  }

  OpenModalVerDetalle = (row) => {
    switch (row.TipoSolicitud) {
      case 12:
        this.props.dispatch(GetDetalleSolicitudReajuste(row.IdSolicitud));
        break;
      case 69:
        this.props.dispatch(GetDetalleSolicitudReajustePQ(row.IdSolicitud));
        break;
      case 71:
        this.props.dispatch(GetDetalleSolicitudPaquete(row.IdSolicitud));
        break;
      default:
        this.props.dispatch(GetDetalleSolicitud(row.IdSolicitud));
    }

    this.props.dispatch(OpenModalVerDetalle(true, row.IdSolicitud));
  }

  GetFileDetalleSolicitudExcel = (row) => {
    switch (row.TipoSolicitud) {
      case 12:
        this.props.dispatch(getDetalleSolBOConvnioReajusteExcel(row.IdSolicitud));
        break;
      default:
        this.props.dispatch(GetFileDetalleSolicitudExcel(row.IdSolicitud));
    }
  }

  GetComprobanteSolicitud = (row) => {
    this.props.dispatch(LoadingFile(true))
    this.props.dispatch(GetComprobanteSolicitud(row.IdSolicitud, row.TipoSolicitud));
  }

  render() {
    const menuListSolicitudes = [];
    if (this.props.solicitudes) {
      this.props.solicitudes.map((row, index) => (
        menuListSolicitudes.push((
          <TableRow key={index}>
            <TableRowColumn style={styles.contTablaSolicitudes1}>{row.IdSolicitud}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudes2}>{(new Date(row.FechaCreacion)).toLocaleDateString()}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudes4}>{this.GetTipoSolicitud(row.TipoSolicitud)}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudes5}>{this.GetEstadoSolicitud(row.EstadoSolicitud)}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudes6}>{row.FechaResolucionConvenio}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudes7}>
              <RaisedButton
                label="Ver"
                primary
                labelStyle={{ fontSize: "11px" }}
                overlayStyle={{ borderRadius: 5 }}
                rippleStyle={{ borderRadius: 5 }}
                style={{
                  paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0, height: 25, width: "60px", minWidth: "40px", borderRadius: 5,
                }}
                buttonStyle={{ borderRadius: 5 }}
                onClick={() => this.OpenModalVerDetalle(row)}
              />

            </TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudes8}>
              {/*
              <RaisedButton
                label="Informe"
                primary
                labelStyle={{ fontSize: "11px" }}
                overlayStyle={{ borderRadius: 5 }}
                rippleStyle={{ borderRadius: 5 }}
                style={{
                  paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0, height: 25, width: "90px", minWidth: "40px", borderRadius: 5,
                }}
                buttonStyle={{ borderRadius: 5 }}
                onClick={() => this.GetFileDetalleSolicitudExcel(row)}
              />
              */}
              {
                !this.props.loadingFile ?
                  row.EstadoSolicitud === 10 ?
                    <RaisedButton
                      label="Comprobante"
                      primary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{
                        paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0, height: 25, borderRadius: 5,
                      }}
                      buttonStyle={{ borderRadius: 5 }}
                      onClick={() => this.GetComprobanteSolicitud(row)}
                      disabled={this.props.loadingFile}
                    />
                    :
                    null
                  :
                  <CircularProgress />
              }
            </TableRowColumn>
          </TableRow>
        ))
      ));
    }

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader

              style={{ paddingTop: "0px", paddingBottom: "0px", width: 850 }}
            >
              <div style={styles.h1}>Resultado Búsqueda</div>
            </CardHeader>
            <CardText>
              {!this.props.loading ?
                <div>
                  <div style={{ width: "900px", textAlign: "center" }}>
                    {(!this.props.solicitudes) ?
                      <span style={{ textAlign: "center" }}>No se encontraron resultados</span>
                      :
                      <Table
                        key="tablaGrillaSolicitudesRealizadas"
                        fixedHeader
                        fixedFooter
                        selectable={false}
                      // height={menuListSolicitudes.length > 8 ? "400px" : null}
                      >
                        <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes1}>N° Solicitud</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes2}>Fecha Solicitud</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes4}>Tipo Solicitud</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes5}>Estado Solicitud</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes6}>Fecha Resolución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes7}>Ver</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudes8}>Comprobante</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          displayRowCheckbox={false}
                          deselectOnClickaway={false}
                          stripedRows={false}
                          style={{ height: 30 }}
                          id="tablaBodyGrillaSolicitudesRealizadas"
                        >
                          {menuListSolicitudes}
                        </TableBody>
                      </Table>
                    }
                  </div>
                  <TablePaginationCustom
                    key="pag_tablaGrillaSolicitudesRealizadas"
                    rowsPerPageDefault={5} // [5,10,15,20,25]
                    totalRows={menuListSolicitudes.length}
                    pageDefault={1}
                    idTableBody="tablaBodyGrillaSolicitudesRealizadas"
                    showRowsPerPage={false}
                    labelStyleBtnPage={{ fontSize: "11px" }}
                    overlayStyleBtnPage={{ borderRadius: 20 }}
                    rippleStyleBtnPage={{ borderRadius: 20 }}
                    buttonStyleBtnPage={{ borderRadius: 20 }}
                    styleBtnPage={{
                      paddingLeft: 0,
                      paddingRight: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      height: 25,
                      width: "45px",
                      minWidth: "45px",
                      borderRadius: 20,
                      marginRight: 5,
                    }}

                    labelStyleRowsPerPage={styles.h4}
                    underlineStyleRowsPerPage={styles.underlineSelectField}
                    iconStyleRowsPerPage={styles.iconSelectField}
                    menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                    selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                    styleRowsPerPage={styles.selectFiledStyle}
                  />
                </div>
                :
                <CircularProgress />
              }
            </CardText>
          </Card>
        </div>


        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalVerDetalle}
          docked={false}
        >
          {this.props.modalVerDetalle ?
            <DetalleSolicitud />
            : null}
        </Drawer>
      </div>
    );
  }
}


GrillaSolicitudes.propTypes = {
  solicitudes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingFile: PropTypes.bool.isRequired,
  tiposSolicitud: PropTypes.array.isRequired,
  estadosSolicitud: PropTypes.array.isRequired,
  modalVerDetalle: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  solicitudes: state.filtroBusquedaSR.solicitudes,
  loading: state.filtroBusquedaSR.loading,
  loadingFile: state.grillaSolicitudes.loadingFile,
  tiposSolicitud: state.global.tiposSolicitud,
  estadosSolicitud: state.global.estadosSolicitud,
  modalVerDetalle: state.grillaSolicitudes.modalVerDetalle,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaSolicitudes);



// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/GrillaSolicitudes/view.jsx